import { KeyboardShortcut, ViewerMode } from 'features/pointClouds'

export const handleViewerModeChange = (
  viewerMode: ViewerMode,
  setViewerMode: (viewerMode: ViewerMode) => void
) => {
  const handleKeyDown = (event: KeyboardEvent) => {
    if (
      event.target instanceof HTMLInputElement ||
      event.target instanceof HTMLTextAreaElement
    ) {
      return
    }

    const key = event.key.toLowerCase()

    // Handle Escape key first
    if (key === KeyboardShortcut.ESCAPE) {
      event.preventDefault()
      setViewerMode(ViewerMode.ENV_CONTROLS)
      return
    }

    if (
      viewerMode !== ViewerMode.POINTER_NAV &&
      (key === KeyboardShortcut.FORWARD ||
        key === KeyboardShortcut.LEFT ||
        key === KeyboardShortcut.BACKWARD ||
        key === KeyboardShortcut.RIGHT ||
        key === KeyboardShortcut.UP ||
        key === KeyboardShortcut.DOWN)
    ) {
      setViewerMode(ViewerMode.POINTER_NAV)
      return
    }

    switch (key) {
      case KeyboardShortcut.ADD_OBSERVATION:
        setViewerMode(ViewerMode.SELECTION)
        break
      case KeyboardShortcut.FREE_MOUSE:
        setViewerMode(ViewerMode.ENV_CONTROLS)
        break
      default:
        break
    }
  }

  // Remove any existing event listeners first
  window.removeEventListener('keydown', handleKeyDown)
  // Add the new event listener
  window.addEventListener('keydown', handleKeyDown)

  return () => {
    window.removeEventListener('keydown', handleKeyDown)
  }
}
